module.exports = __webpack_public_path__ + "static/media/error.3d6bddd4.svg";